﻿//import * as bootstrap from 'bootstrap'

import Alert from '../../../node_modules/bootstrap/js/src/alert'
import Button from '../../../node_modules/bootstrap/js/src/button'
import Carousel from '../../../node_modules/bootstrap/js/src/carousel'
import Collapse from '../../../node_modules/bootstrap/js/src/collapse'
//import Dropdown from '../../../node_modules/bootstrap/js/src/dropdown'
import Modal from '../../../node_modules/bootstrap/js/src/modal'
//import Offcanvas from '../../../node_modules/bootstrap/js/src/offcanvas'
//import Popover from '../../../node_modules/bootstrap/js/src/popover'
//import ScrollSpy from '../../../node_modules/bootstrap/js/src/scrollspy'
//import Tab from '../../../node_modules/bootstrap/js/src/tab'
//import Toast from '../../../node_modules/bootstrap/js/src/toast'
//import Tooltip from '../../../node_modules/bootstrap/js/src/tooltip'

import Filtering from "./components/Filtering"

export default {
    Alert,
    Button,
    Carousel,
    Collapse,
//    Dropdown,
    Modal,
//    Offcanvas,
//    Popover,
//    ScrollSpy,
//    Tab,
//    Toast,
//    Tooltip
}
